'use strict';

var React = require('react');

var SvgMarketingMajor = function SvgMarketingMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10a5.25 5.25 0 0 1 10.5 0 .75.75 0 0 0 1.5 0 6.75 6.75 0 1 0-6.75 6.75.75.75 0 0 0 0-1.5 5.25 5.25 0 0 1-5.25-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.537 9.805a.75.75 0 0 0 1.486-.208 3 3 0 1 0-3.492 3.372.75.75 0 1 0 .26-1.478 1.5 1.5 0 1 1 1.746-1.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61 10.973a.5.5 0 0 0-.637.638l2.121 6.01a.5.5 0 0 0 .871.135l1.172-1.558 1.038 1.037a.5.5 0 0 0 .707 0l.353-.353a.5.5 0 0 0 0-.707l-1.037-1.038 1.558-1.171a.5.5 0 0 0-.135-.872l-6.01-2.12Z"
  }));
};
SvgMarketingMajor.displayName = "MarketingMajor";

exports.SvgMarketingMajor = SvgMarketingMajor;
